import classnames from 'classnames/bind'
import { FC } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'

import Row from '~/components/Panels/SizeGuidePanel/Row'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface TableRowData {
  title: string
  values:
    | {
        cm?: (string | number)[]
        inch?: (string | number)[]
      }
    | (string | number)[]
}

interface TableGuideProps {
  activeUnit: 'CM' | 'INCH'
  data: {
    title: string
    type: string
    rows: TableRowData[]
  }[]
}

const TableGuide: FC<TableGuideProps> = ({ activeUnit, data }) => {
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Haffer,
  })

  return (
    <>
      {data.map((tableData, index) => (
        <div key={index} className={css.tableGuide}>
          <h2 className={cx(titleStyle)}>{tableData.title}</h2>
          <table>
            <tbody>
              {tableData.rows.map((row, index) => (
                <Row
                  key={index}
                  rowIndex={index}
                  activeUnit={activeUnit}
                  title={row.title}
                  type={tableData.type}
                  values={row.values}
                />
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  )
}

export default TableGuide
